import * as React from "react";
import {cx} from "emotion";

import {faAddressBook, faPlus} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}       from "@fortawesome/react-fontawesome";

import "./dnm-modal.scss";

import {cs}                           from "@Common/react/chain-services";
import {consumeContext}               from "@Common/react/context";
import {UseState}                     from "@Common/react/use-state";
import {BubbleNoti}                   from "@Common/ui-components/bubble-noti/bubble-noti";
import {isDevQuan}                    from "@Common/ui-components/debug/is-dev-quan";
import {ModalService3}                from "@Common/ui-components/modal-service-3/modal-service-3";
import {parseUrlQuery}                from "@Common/utils/parse-url-query";
import {removeURLParameterFromWindow} from "@Common/utils/remove-url-parameter";

import {COMPANY_LEVEL} from "@Xpresso/routes/common/logic/user-level";

import {ModalLayout} from "../../../../common/modal-layout/modal-layout";

import {AddAddressModal} from "./add-address/add-address-modal";
import {FindRemoveModal} from "./find-remove-address/find-remove-modal";

export const DnmModal = ({next: rootNext}) => cs(
    consumeContext("userLevels"),
    consumeContext("session"),
    ["addAddressContent", ({}, next) => UseState({initValue: false, next})],
    ["findRemoveContent", ({}, next) => UseState({initValue: false, next})],
    ["modal", ({addAddressContent, findRemoveContent}, next) => ModalService3({
        xdQaName: "Do Not Mail Modal",
        initShow: isDevQuan(),
        rootNext,
        next,
        onClose: async () => {
            if(addAddressContent.value) {
                removeURLParameterFromWindow({parameter: "action"})
                addAddressContent.onChange(false);
            }
            else if(findRemoveContent.value) {
                removeURLParameterFromWindow({parameter: "action"})
                findRemoveContent.onChange(false)
            }
        },
        urlParam: "dnm",
        width: findRemoveContent.value ? 558 : 778,
    })],
    ["officeId", ({userLevels, modal}, next) => modal.params.officeId ? 
        next(modal.params.officeId) : 
        userLevels.userLevel === COMPANY_LEVEL ? next(
        parseUrlQuery(window.location.search)?.office || parseUrlQuery(window.location.search)?.branch
    ) : next(undefined)],

    ["noti", ({}, next) => BubbleNoti({next})],
    ({addAddressContent, officeId, findRemoveContent, modal, noti}) => ModalLayout({
        title: officeId ? "Office Do Not Mail List" : "Company Do Not Mail List",
        content: addAddressContent.value ? ( AddAddressModal({addAddressContent, officeId, modal, noti}) 
        ) : ( 
            findRemoveContent.value ? FindRemoveModal({findRemoveContent, officeId}) : initContent({addAddressContent, findRemoveContent})
        ),
    })
);

const initContent = ({addAddressContent, findRemoveContent}) => cs(
    ({}) => (
        <div className="dnm-modal-5ed">
            <h2 className="title" xd-qa-type="label" xd-qa-name="Exclude Address">Exclude address</h2>
            <span className="subtitle" xd-qa-type="label" xd-qa-name="Exclude Address Subtitle">Add the address you wish to exclude manually or from the mailing list</span>
            <div className="card-grid">
                <button 
                    className="card"
                    xd-qa-type="button"
                    xd-qa-name="Add Address"
                    onClick={() => {addAddressContent.onChange(true)}}>
                    <FontAwesomeIcon icon={faPlus} className="icon"/>
                    <span className="label">Add Address</span>
                </button>
                <button 
                    className="card" 
                    xd-qa-type="button"
                    xd-qa-name="Find/Remove Address"
                    onClick={() => findRemoveContent.onChange(true)}>
                    <FontAwesomeIcon icon={faAddressBook} className="icon"/>
                    <span className="label">Find/Remove Address</span>
                </button>
            </div>
        </div>
    )
)
